import { Color } from './java/Color';
import { AlphaComposite, Graphics2D } from './java/Graphics2D';
import { Rectangle } from './java/Geom';
import { GameObject } from './GameObject';
import { Handler } from './Handler';
import { ID } from './ID';

export class Trail extends GameObject {

  static readonly SHAPE_ROUND_RECT = 0;
  static readonly SHAPE_DIAMOND = 1;
  static readonly SHAPE_CIRCLE = 2;
  static readonly SHAPE_TRIANGLE = 3;
  private static readonly OPAQUE: AlphaComposite = AlphaComposite.getInstance(AlphaComposite.SRC_OVER, 1);

  private alpha = 1;
  private life: number;
  private handler: Handler;
  private color: Color;
  private width: number;
  private height: number;
  private shape: number;

  constructor(
    x: number,
    y: number,
    id: ID,
    color: Color,
    width: number,
    height: number,
    life: number,
    handler: Handler,
    shape: number = Trail.SHAPE_ROUND_RECT,
  ) {
    super(x, y, id);
    this.handler = handler;
    this.color = color;
    this.width = width;
    this.height = height;
    this.life = life;
    this.shape = shape;
  }

  tick(): void {
    if (this.alpha > this.life) {
      this.alpha -= (this.life - 0.0001);
    } else {
      this.handler.removeObject(this);
    }
  }

  render(g: Graphics2D): void {
    const g2 = g;
    g2.setComposite(AlphaComposite.getInstance(AlphaComposite.SRC_OVER, this.alpha));
    g2.setColor(this.color);

    const shrink = Math.trunc((1 - this.alpha) * 4);
    const dx = Math.trunc(this.x) + shrink;
    const dy = Math.trunc(this.y) + shrink;
    const dw = this.width - shrink * 2;
    const dh = this.height - shrink * 2;

    if (dw <= 0 || dh <= 0) {
      g2.setComposite(Trail.OPAQUE);
      return;
    }

    const cx = dx + Math.trunc(dw / 2);
    const cy = dy + Math.trunc(dh / 2);
    const half = Math.trunc(dw / 2);

    switch (this.shape) {
      case Trail.SHAPE_DIAMOND:
        g2.fillPolygon(
          [cx, cx + half, cx, cx - half],
          [cy - half, cy, cy + half, cy], 4);
        break;
      case Trail.SHAPE_CIRCLE:
        g2.fillOval(dx, dy, dw, dh);
        break;
      case Trail.SHAPE_TRIANGLE:
        g2.fillPolygon(
          [cx, cx + half, cx - half],
          [cy - half, cy + half, cy + half], 3);
        break;
      default:
        g2.fillRoundRect(dx, dy, dw, dh, 8, 8);
        break;
    }

    g2.setComposite(Trail.OPAQUE);
  }

  getBounds(): Rectangle {
    return null as unknown as Rectangle;
  }
}
